<script lang="ts" setup>
import { computed } from 'vue'
/**
 * Props
 */
 type Props = {
   name: string
   required?: boolean
 }
const props = withDefaults(defineProps<Props>(), {
  name: '',
  required: false,
})

/**
 * Computed
 */
const htmlId = computed(() => `label-${props.name}`)
</script>

<template>
  <div class="label-with-boxed-required">
    <label
      :for="htmlId"
      class="label"
    >
      <div
        v-if="!!props.required"
        class="required-indicator"
      >
        {{ $t('common.label.required') }}
      </div>
      <span class="label-text">
        <slot name="text" />
      </span>
    </label>

    <slot
      :html-id="htmlId"
      :html-name="props.name"
    />
  </div>
</template>

<style scoped>
.label-with-boxed-required {
  .label {
    display: flex;
    gap: 10px;
    align-items: center;
    margin-bottom: 6px;
    white-space: pre-wrap;
  }

  .label-text {
    font-size: 12px;
    line-height: 12px;
    color: rgb(var(--v-theme-ui-text-black));
  }

  .required-indicator {
    display: flex;
    align-items: center;
    padding: 2px 3px;
    font-size: 10px;
    color: rgb(var(--v-theme-ui-white));
    background-color: rgb(var(--v-theme-ui-graph-blue-2));
    border-radius: 1px;
  }
}
</style>
